import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';

export default function defaultShouldWarn(
  _input: WrappedFieldInputProps,
  meta: WrappedFieldMetaProps,
) {
  return meta.touched;
}
